const jsonToProps = ({ header, content_rows, content_row_link, container_actions, featureName, itemId }) => ({
  header,
  featureName,
  itemId,
  contentRows: content_rows,
  contentRowLink: content_row_link,
  containerActions: container_actions,
});

export default jsonToProps;
